const userGroupAction = {
    NEW_USER_GROUP : 'new user group',

    SAVE : 'save',

    DISCARD : 'discard',

    DELETE : 'delete'

};

angular.module('gw-um-j2js')
    .constant('userGroupAction', userGroupAction);